import { hideSearch } from "./search";
import { ResetMegaMenu } from "./megamenu";

/**
 * Megamenu
 * Use: import { initMenu } from "./components/menu";
 */
export function initMenu() {
	const	MenuItemTopLevel	= $('.menu-item-top-level .main-menu-expander, .child-is-mega .main-menu-expander'),
			SubBackDrop			= $('.sub-menu-backdrop');

	// Toggle mega menu on click
	// --------------------------------------------------------------
	MenuItemTopLevel.on("click", function(){
		const	$this			= $(this),
				ParentLi		= $this.parent(),
				SubMenu			= ParentLi.find('.submenu');

		if( ParentLi.hasClass( 'expanded' ) ) {
			ParentLi.attr("aria-expanded", false).toggleClass('expanded');
			
		} else {
			ResetMainMenu();
			ResetMegaMenu();
			hideSearch();

			ParentLi.attr("aria-expanded", true).toggleClass('expanded');
		}
		
		$this.toggleClass('open');
		SubMenu.toggleClass('is-open');
	});

	SubBackDrop.on("click", function(){
		ResetMainMenu();
	});

	$(document).on('keydown',function(evt) {
		if(evt.keyCode == 27) {
			ResetMainMenu();
		}
	});
}

// Reset Main Menu Items
// --------------------------------------------------------------
export function ResetMainMenu(){
	const	MainMenuToggle		= $('.main-menu-expander'),
			MainMenuParentItem	= MainMenuToggle.parent(),
			MainMenuSubMenu		= MainMenuToggle.parent().find('.submenu');

	// Reset main menu item
	// --------------------------------------------------
	MainMenuParentItem.each(function(){
		if ($(this).attr("aria-expanded") === "true") {
			$(this).attr("aria-expanded", false).removeClass('expanded');
		}
	});

	MainMenuToggle.each(function(){
		$(this).removeClass('open');
	});
	
	MainMenuSubMenu.each(function(){
		$(this).removeClass('is-open');
	});
}